import React, { Component } from 'react'

const ImageCycle = props => (
	<div
		className="image-cycle"
		style={{
			background: `url(${props.image.file.url}) top center no-repeat`,
			backgroundSize: 'cover'
		}}
	/>
)

export default ImageCycle



// WEBPACK FOOTER //
// ./src/components/ImageCycle/index.js